// // components/Fields/CustomTimeTextField.jsx
// import React from 'react';
// import { TextField, useTheme } from '@mui/material';
// import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// const CustomTimeTextField = ({
//   label,
//   value,
//   onChange,
//   name,
//   error,
//   helperText,
//   ...rest
// }) => {
//   const theme = useTheme();

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <TimePicker
//         ampm
//         inputFormat="hh:mm a"
//         mask="__:__ _M"
//         label={label}
//         value={value}
//         fullWidth
//         onChange={val => onChange({ target: { name, value: val } })}
//         renderInput={params => (
//           <TextField
//             {...params}
//             name={name}
//             error={Boolean(error)}
//             helperText={helperText}
//             InputProps={{
//               ...params.InputProps,
//               sx: {
//                 '& .MuiInputBase-input-MuiOutlinedInput-input': {
//                   padding: '8px 12px !important',
//                 },
//                 borderRadius: theme.formFileds?.borderRadius || 4,
//                 height: theme.formFileds?.height || 40,
//               }
//             }}
//             {...rest}
//           />
//         )}
//       />
//     </LocalizationProvider>
//   );
// };

// export default CustomTimeTextField;




// components/Fields/CustomTimeTextField.jsx
import React from 'react';
import { TextField, Typography, useTheme } from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const CustomTimeTextField = ({
    label,
    value,
    onChange,
    onBlur,
    name,
    error,
    helperText,
    sx,
    shouldDisableTime,
    ...rest
}) => {
    const theme = useTheme();

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    ampm
                    className='custom-time-picker'
                    inputFormat="hh:mm a"
                    mask="__:__ _M"
                    value={value}
                    onChange={onChange}
                    shouldDisableTime={shouldDisableTime}
                    fullWidth
                    renderInput={params => (
                        <TextField
                            {...params}
                            name={name}
                            fullWidth
                            onBlur={onBlur}
                            error={error}
                            helperText={helperText}
                            sx={{ height: 45, ...sx }}
                            InputProps={{
                                ...params.InputProps,
                                sx: {
                                    '& .MuiOutlinedInput-input': { padding: '8px 12px !important' },
                                    borderRadius: theme.formFileds?.borderRadius || 4,
                                    height: 45
                                }
                            }}
                            {...rest}
                        />
                    )}
                />
            </LocalizationProvider>
            {error && helperText &&
                <Typography variant='subtitle2' color='error' sx={{ fontWeight: 'normal' }}>{helperText}</Typography>
            }
        </>
    );
};

export default CustomTimeTextField;
